import Vue from 'vue'
import moment from "moment";

Vue.filter('toCommas', str => {
  var isNumber = !isNaN(str)
  if (isNumber) {
    var float = str.toString().includes('.')
    var value = null
    if (float) {
      var splittedByDot = Number(str).toFixed(2).split('.')
      value = splittedByDot[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + splittedByDot[1]
    } else {
      value = str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
    return value
  } else {
    return 0
  }
})

Vue.filter('shortDate', date => {
  if (date) {
    return moment(date).format('DD MMM YYYY')
  } else {
    return ''
  }
})

Vue.filter('shortFullDate', date => {
  if (date) {
    return moment(date).format('MMM Do YYYY')
  } else {
    return ''
  }
})

Vue.filter('getFormattedDate', date => {
  var yearDifference = moment().diff(moment(date), 'years');
  var monthDifference = moment().diff(moment(date), 'months');
  var dayDifference = moment().diff(moment(date), 'days');
  var hourDifference = moment().diff(moment(date), 'hours');
  var minDifference = moment().diff(moment(date), 'minutes');
  if (yearDifference >= 1) {
    return yearDifference == 1 ? yearDifference + ' year ago' : yearDifference + ' years ago';
  } else if (monthDifference >= 1) {
    return monthDifference == 1 ? monthDifference + ' month ago' : monthDifference + ' months ago';
  } else if (dayDifference >= 1) {
    return dayDifference == 1 ? dayDifference + ' day ago' : dayDifference + ' days ago';
  } else if (hourDifference >= 1) {
    return hourDifference == 1 ? hourDifference + ' hour ago' : hourDifference + ' hours ago';
  } else if (minDifference >= 1) {
    return minDifference == 1 ? minDifference + ' min ago' : minDifference + ' mins ago';
  } else {
    return 'just now';
  }
})

Vue.filter('shortCount', str => {
  var isNumber = !isNaN(str)
  var valueToReturn = 0
  if (isNumber) {
    if (str < 1000) {
        valueToReturn = str
    } else if (str < 999999) {
        valueToReturn = (str / 1000).toFixed(1)
        valueToReturn.split('.')[1] == 0 ? valueToReturn = valueToReturn.split('.')[0] : ''
        valueToReturn = valueToReturn + 'k'
    } else if (str < 999999999) {
        valueToReturn = (str / 1000000).toFixed(1)
        valueToReturn.split('.')[1] == 0 ? valueToReturn = valueToReturn.split('.')[0] : ''
        valueToReturn = valueToReturn + 'm'
    } else {
        valueToReturn = (str / 1000000000).toFixed(1)
        valueToReturn.split('.')[1] == 0 ? valueToReturn = valueToReturn.split('.')[0] : ''
        valueToReturn = valueToReturn + 'b'
    }
    return valueToReturn
  } else {
    return 0
  }
})

Vue.filter('megabytes', bytes => {
  return (bytes / 1048576).toFixed(2) + ' MB'
})